<div class="dea-report-page-container">
  <div class="header-container">
    <div class="text-title-2">DEA Compliant Inventory Reports</div>

    <div class="header-controls">
      <app-button customClasses="px-4"
                  [minWidth]="0"
                  [text]="'New Report'"
                  (clicked)="newReport()"
      ></app-button>
    </div>
  </div>

  <div class="reports-table-container">
    <div *ngIf="(isLoading$ | async) !== true && !deaRecordsList?.length" class="empty-list-container">
      <div class="icon-wrapper">
        <img class="chart-icon" src="assets/icons/icon-chart-active.svg" alt="report-icon"/>
      </div>
      <div class="empty-list-header">Report History</div>
      <div class="empty-list-description">
        There are no DEA Compliant reports to display.
      </div>
    </div>

    <table *ngIf="deaRecordsList?.length > 0" class="table-primary report-records-table">
      <thead>
      <tr>
        <th (click)="sortByColumn('createdDate')" class="text-left sort date" scope="col">
          Date
          <img [class.asc]="tableColumns.createdDate" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortByColumn('title')" class="text-left sort report" scope="col">
          Report
          <img [class.asc]="tableColumns.title" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortByColumn('signerFirstName')" class="text-left sort created-by" scope="col">
          Performed by
          <img [class.asc]="tableColumns.signerFirstName" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortByColumn('witness')" class="text-left sort created-by" scope="col">
          Witness
          <img [class.asc]="tableColumns.witness" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th (click)="sortByColumn('recordCount')" class="text-right sort records" scope="col">
          Records
          <img [class.asc]="tableColumns.recordCount" class="sort-icon" src="assets/icons/icon-arrow-down.svg" alt="asc"/>
        </th>
        <th class="text-right controls" scope="col">
          <!-- Controls -->
        </th>
      </tr>
      </thead>
      <tbody>
      <tr class="table-row" *ngFor="let record of deaRecordsList">
        <td class="text-left date">
          {{record.createdDate | formattedDate: 'MM d a, yyyy'}}
        </td>
        <th class="text-left report" scope="row">
          <div class="name-container">
            <app-badge *ngIf="record.isBiennial" [isOption]="false">Biennial</app-badge>
            {{record.title}}
          </div>
        </th>
        <td class="text-left created-by">
          {{record.signerFirstName}} <ng-container *ngIf="record.signerLastName && record.signerLastName[0]">{{record.signerLastName[0]}}.</ng-container>
        </td>
        <td class="text-left created-by">
          {{record.witnessFirstName}} <ng-container *ngIf="record.witnessLastName && record.witnessLastName[0]">{{record.witnessLastName[0]}}.</ng-container>
        </td>
        <td class="text-right records">
          {{record.recordCount | number}}
        </td>

        <td class="text-right controls">
          <app-button customClasses="px-5"
                      subStyle="white"
                      [minWidth]="0"
                      [text]="'View'"
                      (clicked)="viewReport(record.id)"
          ></app-button>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <th scope="row">{{deaRecordsList.length}} Report{{deaRecordsList.length > 1 ? 's' : ''}}</th>
      </tfoot>
    </table>

  </div>
</div>

<app-run-report-dialog [show]="showNewReportDialog"
                       (cancel)="showNewReportDialog = false"
                       (runReport)="runReport($event)"
></app-run-report-dialog>
